var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "elevation-0 py-6",
      class: {
        "elevation-2 px-4": !_vm.$vuetify.breakpoint.mobile,
      },
      attrs: { rounded: "lg" },
    },
    [
      _c(
        "div",
        { staticClass: "mx-2 mt-4 mb-0" },
        [
          _c("v-img", {
            attrs: { src: "/assets/img/logo.png", height: "70px", contain: "" },
          }),
        ],
        1
      ),
      _c(
        "v-toolbar",
        { attrs: { flat: "" } },
        [
          _c("v-toolbar-title", { staticClass: "overline mx-auto" }, [
            _vm._v(" " + _vm._s(_vm.$t("title-create-new-account")) + " "),
          ]),
        ],
        1
      ),
      _c(
        "v-card-text",
        { staticClass: "py-0" },
        [
          _c(
            "v-form",
            {
              attrs: { onSubmit: "return false;" },
              on: { submit: _vm.onCheckPhoneValid },
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("label-phone"),
                  "prepend-inner-icon": "mdi-cellphone",
                  type: "text",
                  outlined: "",
                  autofocus: "",
                  disabled: _vm.isLoading,
                },
                model: {
                  value: _vm.$v.phone.$model,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.$v.phone,
                      "$model",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "$v.phone.$model",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        { staticClass: "d-flex flex-column px-4" },
        [
          _c(
            "v-btn",
            {
              attrs: {
                width: "100%",
                "x-large": "",
                color: "primary",
                depressed: "",
                loading: _vm.isLoading,
                disabled: _vm.isLoading || _vm.$v.$invalid,
              },
              on: { click: _vm.onCheckPhoneValid },
            },
            [_vm._v(_vm._s(_vm.$t("next")) + " ")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "mx-0 my-2",
              attrs: {
                width: "100%",
                "x-large": "",
                depressed: "",
                disabled: _vm.isLoading,
                to: "/auth/login",
              },
            },
            [_vm._v(_vm._s(_vm.$t("back")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }